// import { useMemo } from "react";
import { Column } from "./column";
import { CardType } from "./types";
import { TodoViewModal } from "./todo-view-modal";

export const Board = ({ cardsData }: { cardsData: CardType[] }) => {
  return (
    <div className="flex h-full w-full gap-8 overflow-x-scroll p-12">
      <Column
        title="Pending"
        column="Pending"
        headingColor="text-neutral-500"
        cards={cardsData}
      />

      <Column
        title="Started"
        column="Started"
        headingColor="text-yellow-500"
        cards={cardsData}
      />

      <Column
        title="Update Required"
        column="Update Required"
        headingColor="text-blue-500"
        cards={cardsData}
      />

      <Column
        title="Testing"
        column="Testing"
        headingColor="text-emerald-400"
        cards={cardsData}
      />
      <Column
        title="Finished"
        column="Finished"
        headingColor="text-green-500"
        cards={cardsData}
      />

      <TodoViewModal />
    </div>
  );
};
